<script type="text/javascript">
const app = ''
const platform = ''
const ver = ''
// const imgUrl='https://faces-01.oss-cn-shenzhen.aliyuncs.com/wxMall/homesearch_cat_icon'
const imgUrl='https://faces-01.oss-cn-shenzhen.aliyuncs.com/guanwang/'
export default
{
  app,
  platform,
  ver,
  imgUrl
}
</script>




// WEBPACK FOOTER //
// src/store/global.vue